// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"da9426ea","455":"dd8636df","977":"1bf60dc6"}[chunkId] + ".chunk.js";
};